import { useSelector } from 'react-redux'

import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'
import {
  GetIsEAPSessionCountExhaustedOptions,
  useGetIsEAPSessionCountExhaustedShared,
} from '@lyrahealth-inc/shared-app-logic/src/features/searchForCare/hooks/useGetIsEAPSessionCountExhausted'

import {
  getIsEAPSessionCountExhaustedByProgramGetter,
  getIsUserEAPSessionCountExhausted,
} from '../../data/user/userSelectors'

export function useGetIsEAPSessionCountExhausted() {
  const { forceAdultFlowsToHPI: forceAdultFlowsToHPIForAmazonExceptCFP } = useFlags()
  const isUserEAPSessionCountExhausted = useSelector(getIsUserEAPSessionCountExhausted)
  const isUserEAPSessionCountExhaustedWithoutOverrides = useSelector((state) =>
    getIsUserEAPSessionCountExhausted(state, true),
  )
  const getIsEAPSessionCountExhaustedByProgram = useSelector(getIsEAPSessionCountExhaustedByProgramGetter)

  return useGetIsEAPSessionCountExhaustedShared(
    isUserEAPSessionCountExhausted,
    isUserEAPSessionCountExhaustedWithoutOverrides,
    getIsEAPSessionCountExhaustedByProgram,
    forceAdultFlowsToHPIForAmazonExceptCFP,
  )
}

export function useIsEAPSessionCountExhausted(options: GetIsEAPSessionCountExhaustedOptions) {
  const getIsEAPSessionCountExhaustedByProgram = useGetIsEAPSessionCountExhausted()
  return getIsEAPSessionCountExhaustedByProgram(options)
}
